<template>
  <v-card @dragover.prevent="dragOver" @dragleave.prevent="dragLeave" @drop.prevent="fileDrop">
    <v-card-title :class=" drag ? 'green' : 'secondary'">
      <v-icon dark class>{{icon}}</v-icon>

      <!--
    <div class="" v-if="revisions">
      <v-icon color="warning" v-if="revisions.length">fa-exclamation-triangle</v-icon>
    </div>
      !-->

      <v-spacer></v-spacer>
      <h5 class="white--text">{{title}}</h5>

      <v-spacer></v-spacer>

      <v-icon color="warning" v-if="revisions.length">fa-exclamation-triangle</v-icon>

      <v-btn @click="$eventBus.$emit('play_video',tutorial)" small icon dark v-else-if="tutorial">
        <v-icon>fa-question</v-icon>
      </v-btn>

      <v-btn icon v-else>
        <v-icon>fa-blank</v-icon>
      </v-btn>
    </v-card-title>

    <v-container class="secondary lighten-1 py-1 white--text" v-if="revisions.length">
      <!-- Section for revision info !-->
      <v-row align="center" v-for="(revision,i) in revisions" :key="i">
        <v-col cols="4" md="2" class v-if="revision.video">
          <v-btn
            color="warning"
            outlined
            class
            x-large
            :height="81"
            @click="$eventBus.$emit('play_video',revision.video)"
          >
            <div class="mt-2">
              <v-icon large dark>fa-play</v-icon>
              <br />
              <span class="caption white--text">Message</span>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="8" md="7" class="pr-1">
          <div>
            <h5>Message from editor</h5>
            <p class="mb-0">{{revision.note}}</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-divider class="mb-0 py-0"></v-divider>

    <v-container class="pt-0">
      <v-row v-if="single" justify="center">
        <v-col cols="12" md="10" v-for="(video,i) in videos" :key="'v'+i">
          <v-card class="clicky">
            <v-card-actions
              class="warning pa-2 white--text"
              v-if="video.revision_required===1 && revisions.length"
            >
              <h5>Revision Required</h5>
            </v-card-actions>

            <div class="video-responsive">
              <video controls :poster="video.thumbnail ? video.thumbnail : '/placeholder.png'">
                <source :src="video.url" type="video/mp4" />
                <source :src="video.url" type="video/ogg" />Your browser does not support HTML5 video.
              </video>
            </div>
            <v-card-actions class="grey lighten-3 pa-0" v-if="can_delete || video.is_revision">
              <v-spacer></v-spacer>
              <v-btn icon small @click="$emit('delete',video)">
                <v-icon small>fa-times</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          cols="6"
          md="4"
          lg="3"
          class="text-center"
          v-for="(upload,i) in uploads"
          :key="'u'+i"
        >
          <v-progress-circular
            :value="upload.progress"
            :size="100"
            :width="8"
            color="green"
          >{{ upload.progress }}</v-progress-circular>
        </v-col>

        <v-col
          cols="6"
          md="4"
          lg="3"
          class="text-center"
          style="padding:50px"
          v-if="can_upload && canUpload"
        >
          <v-btn class fab x-large dark color="primary" @click="openFileSelect()">
            <v-icon>fa-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row align="center" v-else :justify="uploads.length || videos.length ? 'start' : 'center'">
        <v-col cols="6" md="4" lg="3" v-for="(video,i) in videos" :key="'v'+i">
          <v-card class="clicky">
            <v-card-actions
              class="warning pa-2 white--text"
              v-if="video.revision_required===1 && revisions.length"
            >
              <h5>Revision Required</h5>
            </v-card-actions>

            <div class="video-responsive">
              <video controls :poster="video.thumbnail ? video.thumbnail : '/placeholder.png'">
                <source :src="video.url" type="video/mp4" />
                <source :src="video.url" type="video/ogg" />Your browser does not support HTML5 video.
              </video>
            </div>
            <v-card-actions class="grey lighten-3 pa-0" v-if="can_delete || video.is_revision">
              <v-spacer></v-spacer>
              <v-btn icon small @click="$emit('delete',video)">
                <v-icon small>fa-times</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col
          cols="6"
          md="4"
          lg="3"
          class="text-center"
          v-for="(upload,i) in uploads"
          :key="'u'+i"
        >
          <v-progress-circular
            :value="upload.progress"
            :size="100"
            :width="8"
            color="green"
          >{{ upload.progress }}</v-progress-circular>
        </v-col>

        <v-col cols="6" md="4" lg="3" class="text-center" style="padding:50px" v-if="can_upload">
          <v-btn class fab x-large dark color="primary" @click="openFileSelect()">
            <v-icon>fa-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <input
      type="file"
      style="display:none"
      accept="video/*"
      :id="`videos-file-${section}-${random_id}`"
      @change="handleFileChange"
      multiple
    />
  </v-card>
</template>
<script>
export default {
  props: [
    "title",
    "icon",
    "section",
    "tutorial",
    "videos",
    "uploads",
    "can_delete",
    "can_upload",
    "revisions",
    "single",
  ],
  name: "ProjectVideos",
  data: () => ({
    random_id: Math.round(Math.random() * 100000),
    drag: false,
  }),
  computed: {
    canUpload() {
      if (this.single) {
        if (this.revisions.length && !this.uploads.length) {
          return true;
        }
        if (this.videos.length || this.uploads.length) {
          return false;
        }
      }
      return true;
    },
  },
  methods: {
    dragOver() {
      this.drag = true;
    },
    dragLeave() {
      this.drag = false;
    },
    openFileSelect() {
      document
        .querySelector(`#videos-file-${this.section}-${this.random_id}`)
        .click();
    },
    handleFileChange(ev) {
      ev.preventDefault();
      let files = ev.target.files;
      for (var i = 0; i < files.length; i++) {
        this.$emit("video", {
          section: this.section,
          file: files[i],
        });
      }
      ev.target.value = null;
    },
    fileDrop(ev) {
      this.drag = false;
      ev.preventDefault();
      var dt = event.dataTransfer;
      var files = dt.files;
      for (var i = 0; i < files.length; i++) {
        this.$emit("video", {
          section: this.section,
          file: files[i],
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dropzone {
  z-index: 100;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
}
.dropzone-active {
  opacity: 1;
}
.video-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}
.video-responsive video {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
.video-responsive img {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
</style>
